import { useTheme } from "@/hooks/use-theme.hook";
import { Sun, Moon, TreePine, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

const THEMES = [
  { value: "light", Icon: Sun, labelKey: "common.themeLight" },
  { value: "dark", Icon: Moon, labelKey: "common.themeDark" },
  { value: "forest", Icon: TreePine, labelKey: "common.themeForest" },
] as const;

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();

  const current = THEMES.find((th) => th.value === theme) ?? THEMES[0];
  const { Icon } = current;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn("h-8 w-8", className)}
          aria-label={t("common.switchTheme")}
        >
          <Icon className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {THEMES.map(({ value, Icon: ItemIcon, labelKey }) => (
          <DropdownMenuItem
            key={value}
            onClick={() => setTheme(value)}
            className="flex cursor-pointer items-center gap-2"
          >
            <ItemIcon className="h-4 w-4" />
            <span>{t(labelKey as Parameters<typeof t>[0])}</span>
            {theme === value && <Check className="ml-auto h-3.5 w-3.5" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
